// ImageSlider.jsx

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const CommonImageSlider = (props) => {
  return (
    <div className="w-full max-w-4xl mx-auto mt-1">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={3}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop
        className="rounded-xl overflow-hidden shadow-lg"
      >
        {props.images.map((img, idx) => (
          <SwiperSlide key={idx}>
            <img src={img} alt={`Slide ${idx + 1}`} className="w-full h-80 object-contain" />
          </SwiperSlide>
        ))}
         <style jsx>{`
    .swiper-button-next,
    .swiper-button-prev {
      color: white;
      display:none;
    }
  `}</style>
      </Swiper>
    </div>
  );
};

export default CommonImageSlider;
